import type { Anchor } from "@/types/live";

export const anchors: Anchor[] = [
  {
    id: "a1",
    name: "梨子小队长",
    avatar: "https://readdy.ai/api/search-image?query=friendly%20young%20asian%20female%20streamer%20portrait%20with%20warm%20orange%20studio%20lighting%20and%20clean%20gradient%20background%2C%20professional%20avatar%20photo&width=200&height=200&seq=mili-anchor-01&orientation=squarish",
    followers: 1286000,
    level: "vip",
    bio: "每晚八点陪你一起看剧聊八卦，元气满满的开播小队长。",
    categoryKey: "entertainment",
  },
  {
    id: "a2",
    name: "夜航星",
    avatar: "https://readdy.ai/api/search-image?query=cool%20young%20asian%20male%20gamer%20portrait%20with%20neon%20accent%20lighting%20and%20dark%20clean%20background%2C%20professional%20avatar%20photo&width=200&height=200&seq=mili-anchor-02&orientation=squarish",
    followers: 943000,
    level: "vip",
    bio: "硬核电竞选手，专注射击与战术竞技，深夜上分不打烊。",
    categoryKey: "game",
  },
  {
    id: "a3",
    name: "甜筒不加糖",
    avatar: "https://readdy.ai/api/search-image?query=cheerful%20asian%20female%20host%20portrait%20with%20soft%20cream%20tone%20lighting%20and%20clean%20pastel%20background%2C%20professional%20avatar%20photo&width=200&height=200&seq=mili-anchor-03&orientation=squarish",
    followers: 512000,
    level: "normal",
    bio: "搞笑脱口秀与综艺连麦，快乐就是我的开播理由。",
    categoryKey: "entertainment",
  },
  {
    id: "a4",
    name: "老张说游戏",
    avatar: "https://readdy.ai/api/search-image?query=mature%20asian%20male%20game%20commentator%20portrait%20with%20warm%20studio%20lighting%20and%20clean%20neutral%20background%2C%20professional%20avatar%20photo&width=200&height=200&seq=mili-anchor-04&orientation=squarish",
    followers: 688000,
    level: "vip",
    bio: "十年老玩家的游戏解说与评测，讲解细致不迷路。",
    categoryKey: "game",
  },
  {
    id: "a5",
    name: "木木酱",
    avatar: "https://readdy.ai/api/search-image?query=gentle%20asian%20female%20singer%20portrait%20with%20warm%20amber%20lighting%20and%20clean%20gradient%20background%2C%20professional%20avatar%20photo&width=200&height=200&seq=mili-anchor-05&orientation=squarish",
    followers: 427000,
    level: "normal",
    bio: "温柔女声翻唱现场，点歌必应，用音乐治愈每个夜晚。",
    categoryKey: "music",
  },
  {
    id: "a6",
    name: "舞见小葵",
    avatar: "https://readdy.ai/api/search-image?query=energetic%20asian%20female%20dancer%20portrait%20with%20stage%20lighting%20and%20clean%20warm%20background%2C%20professional%20avatar%20photo&width=200&height=200&seq=mili-anchor-06&orientation=squarish",
    followers: 356000,
    level: "normal",
    bio: "国风与现代舞随心切换，用身体讲故事。",
    categoryKey: "talent",
  },
  {
    id: "a7",
    name: "城市漫游者",
    avatar: "https://readdy.ai/api/search-image?query=traveler%20asian%20male%20portrait%20with%20natural%20daylight%20and%20clean%20outdoor%20background%2C%20professional%20avatar%20photo&width=200&height=200&seq=mili-anchor-07&orientation=squarish",
    followers: 289000,
    level: "normal",
    bio: "带你看遍城市角落与远方风景，户外慢直播爱好者。",
    categoryKey: "outdoor",
  },
  {
    id: "a8",
    name: "深夜电台阿哲",
    avatar: "https://readdy.ai/api/search-image?query=calm%20asian%20male%20radio%20host%20portrait%20with%20warm%20dim%20lighting%20and%20deep%20clean%20background%2C%20professional%20avatar%20photo&width=200&height=200&seq=mili-anchor-08&orientation=squarish",
    followers: 634000,
    level: "vip",
    bio: "深夜陪你聊感情、聊生活，做你睡前的那个声音。",
    categoryKey: "chat",
  },
  {
    id: "a9",
    name: "像素骑士",
    avatar: "https://readdy.ai/api/search-image?query=young%20asian%20male%20retro%20gamer%20portrait%20with%20colorful%20accent%20lighting%20and%20clean%20dark%20background%2C%20professional%20avatar%20photo&width=200&height=200&seq=mili-anchor-09&orientation=squarish",
    followers: 198000,
    level: "normal",
    bio: "复古像素游戏与独立游戏挖掘者，小众神作收集狂。",
    categoryKey: "game",
  },
  {
    id: "a10",
    name: "温柔一夏",
    avatar: "https://readdy.ai/api/search-image?query=elegant%20asian%20female%20host%20portrait%20with%20soft%20warm%20lighting%20and%20clean%20minimal%20background%2C%20professional%20avatar%20photo&width=200&height=200&seq=mili-anchor-10&orientation=squarish",
    followers: 377000,
    level: "normal",
    bio: "治愈系聊天与生活分享，愿你被这个夏天温柔以待。",
    categoryKey: "chat",
  },
  {
    id: "a11",
    name: "山野小满",
    avatar: "https://readdy.ai/api/search-image?query=outdoor%20asian%20male%20camper%20portrait%20with%20natural%20sunlight%20and%20clean%20forest%20background%2C%20professional%20avatar%20photo&width=200&height=200&seq=mili-anchor-11&orientation=squarish",
    followers: 156000,
    level: "normal",
    bio: "露营、徒步与野外美食，把山野生活搬进直播间。",
    categoryKey: "outdoor",
  },
  {
    id: "a12",
    name: "吉他手阿凯",
    avatar: "https://readdy.ai/api/search-image?query=young%20asian%20male%20guitarist%20portrait%20with%20warm%20stage%20lighting%20and%20clean%20background%2C%20professional%20avatar%20photo&width=200&height=200&seq=mili-anchor-12&orientation=squarish",
    followers: 231000,
    level: "normal",
    bio: "民谣与原创弹唱，一把吉他一个夜晚。",
    categoryKey: "music",
  },
];

export const getAnchorById = (id: string): Anchor | undefined =>
  anchors.find((item) => item.id === id);